import { h, Component } from "preact";

import style from "./style.css";
import Letter from "./letter";

class Alphabet extends Component {
  state = {
    alphabet: [],
    setPhrase: false,
    selectedIdx: null,
  };

  componentDidMount() {
    const { alphabet, setPhrase } = this.props;

    this.setState((previousState) => ({
      ...previousState,
      alphabet,
      setPhrase,
    }));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.resetAlphabet) {
      // This means a new alphabet has to be created, because a new search type was selected
      this.resetAlphabet(nextProps);
    }
  }

  handleClick = (idx) => {
    this.setState(
      (previousState) => ({
        ...previousState,
        // If the same letter is clicked again, it means a reset
        selectedIdx: previousState.selectedIdx === idx ? null : idx,
      }),
      () => {
        const newLetter =
          this.state.selectedIdx === null
            ? false
            : this.state.alphabet[this.state.selectedIdx];

        // Emit new letter to be filtered by
        this.props.setFilterByLetter(newLetter);
      }
    );
  };

  resetAlphabet = ({ alphabet, setPhrase }) => {
    this.setState((previousState) => ({
      ...previousState,
      selectedIdx: null,
      setPhrase,
      alphabet,
    }));
  };

  render() {
    return (
      <div class={style["alphabet"]}>
        {this.state.alphabet?.map((letter, index) => (
          <Letter
            key={index}
            index={index}
            letter={letter}
            isActive={this.state.selectedIdx === index}
            handleClick={this.handleClick.bind(null, index)}
          />
        ))}
      </div>
    );
  }
}

export default Alphabet;
